import { StyleSheet } from 'react-native'
import { Theme } from '@theme'

export const getDetailProfileStyle = (theme: Theme) =>
  StyleSheet.create({
    contentContainer: {
      paddingBottom: theme.spacing.lg,
    },
    // Room for the floating arrow (its offset, its height and some air), so
    // the last card can be scrolled clear of it.
    contentContainerWithFloating: {
      paddingBottom:
        theme.spacing.xl + theme.iconSize.small + theme.spacing.sm * 2 + theme.spacing.lg,
    },
    content: {
      flex: 1,
    },
    notFound: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      gap: theme.spacing.md,
      paddingHorizontal: theme.spacing.xl,
    },
    notFoundText: {
      textAlign: 'center',
    },
    rightSection: {
      flexDirection: 'row',
      alignSelf: 'flex-end',
      alignItems: 'center',
      gap: theme.spacing.sm,
      marginRight: theme.spacing.lg,
      height: theme.spacing.xxxl,
    },
    menuButton: {
      padding: theme.spacing.xs,
    },
    infoContainer: {
      flexDirection: 'row',
      alignItems: 'flex-end',
      gap: 15,
      paddingHorizontal: theme.spacing.md,
    },
    infoTextContainer: {
      flex: 1,
    },
    titleContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      marginBottom: theme.spacing.xs,
      marginTop: theme.spacing.xxl,
    },
    titleContainerExtension: {
      marginTop: theme.spacing.xl,
    },
    name: {
      flex: 1,
      textAlign: 'left',
    },
    locationContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      flexShrink: 1,
    },
    locationText: {
      marginLeft: theme.spacing.xs,
      flexShrink: 1,
    },
    work: {
      marginBottom: theme.spacing.xs,
    },
    row: {
      flexDirection: 'row',
      alignItems: 'center',
      flexWrap: 'wrap',
      columnGap: 20,
      rowGap: theme.spacing.xs,
    },
    actionButtonsContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-around',
      paddingHorizontal: theme.spacing.lg,
      marginBottom: theme.spacing.lg,
    },
    container: {
      marginHorizontal: theme.spacing.lg,
      paddingVertical: theme.spacing.xl,
      borderWidth: 1,
      borderColor: theme.colors.grey,
      borderRadius: theme.border.jumbo,
    },
    // Same side padding as the sections it stands in for (ProfileSection).
    strangerNotice: {
      paddingHorizontal: theme.spacing.xl,
    },
    // On phone there is no box around it to give it air.
    strangerNoticeMobile: {
      paddingVertical: theme.spacing.lg,
    },
    floatingPanel: {
      position: 'absolute',
      right: theme.spacing.lg,
      bottom: theme.spacing.xl,
      alignItems: 'center',
    },
    floatingContent: {
      alignItems: 'center',
      gap: theme.spacing.sm,
      marginBottom: theme.spacing.sm,
    },
    floatingDeleteButton: {
      width: 44,
      height: 44,
      borderRadius: 22,
      borderWidth: 1,
      borderColor: theme.colors.error,
      backgroundColor: theme.colors.white,
      justifyContent: 'center',
      alignItems: 'center',
    },
    floatingToggle: {
      backgroundColor: theme.colors.white,
      borderRadius: 999,
      padding: theme.spacing.sm,
      shadowColor: '#000',
      shadowOpacity: 0.12,
      shadowRadius: 8,
      shadowOffset: { width: 0, height: 2 },
      elevation: 4,
    },
  })
